import "./footer.css";
import CotownLogoWhite from "../../../assets/images/cotown-logo-white.webp";
import TvmLogo from "../../../assets/images/tvm-logo.svg";
import DambisLogo from "../../../assets/images/Dambis-logo.png";
import EULogo from "../../../assets/images/EU_logo.png";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { logOut, selectUser } from "../../../app/features/usersSlice";
import { signOut } from "../../../services/userService";
import { Link, useNavigate } from "react-router-dom";
import FacebookIcon from "../../../assets/images/FacebookIcon.webp";
import LinkedInIcon from "../../../assets/images/LinkedInIcon.webp";
import TwitterIcon from "../../../assets/images/TwitterIcon.webp";
import EuropeLogoMobile from "../../../assets/images/EuropeLogoMobile.webp";
import MakeLogo from "../../../assets/images/MakeLogo.webp";
import TechnopolLogo from "../../../assets/images/TechnopolLogo.webp";

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);

  const logOutUser = async () => {
    await dispatch(logOut());
    await signOut();
  };
  const currentYear = new Date().getFullYear();

  const checkAdminAreaNavigation = () => {
    return user[0]?.role === "admin" ? navigate(`/admin/${user[0]?.domain}`) : navigate('/admin')
  }

  return (
    <footer className="footer">
        <div className="cotown_logo_wrapper_mobile">
          <a href="https://cotown.eu">
            <img className="cotown_footer_logo_mobile" src={CotownLogoWhite} />
          </a>
        </div>
        <div className="footer-box">
          <div className="column cotown_data">
            <div className="cotown_logo_tab_desk">
              <img
                className="cotown_footer_logo_tablet"
                src={CotownLogoWhite}
              />
            </div>
            <div className="cotown_app_info">
              Empowering communities to visualize and co-create urban
              improvements. Collaborate, innovate, and transform for vibrant
              cities.
            </div>
            <div className="contacts_logo_wrapper_tablet">
              <div className="tvm_logo">
                <p className="tvm_title">{t("developedBy")}</p>
                <a href="https://www.tvm-engineering.com/" target="_blank">
                  <img className="tvm-logo" src={TvmLogo} />
                </a>
              </div>
              <div className="dambis_logo">
                <p className="dambis_title">{t("partners")}</p>
                <a href="https://www.dambis.ee/en/" target="_blank">
                  <img className="tvm-logo" src={DambisLogo} />
                </a>
              </div>
            </div>
            <div className="contacts_logo_wrapper_desktop">
              <div className="tvm_logo">
                <p className="tvm_title">{t("developedBy")}</p>
                <a href="https://www.tvm-engineering.com/" target="_blank">
                  <img className="tvm-logo" src={TvmLogo} />
                </a>
              </div>
              <div className="dambis_logo">
                <p className="dambis_title">{t("partners")}</p>
                <a href="https://www.dambis.ee/en/" target="_blank">
                  <img className="tvm-logo" src={DambisLogo} />
                </a>
              </div>
            </div>
            <div className="column links_socials_mobile">
              <div className="contacts_logo_wrapper_mobile">
                <div className="tvm_logo">
                  <p className="tvm_title">{t("developedBy")}</p>
                  <a href="https://www.tvm-engineering.com/" target="_blank">
                    <img className="tvm-logo" src={TvmLogo} />
                  </a>
                </div>
                <div className="dambis_logo">
                  <p className="dambis_title">{t("partners")}</p>
                  <a href="https://www.dambis.ee/en/" target="_blank">
                    <img className="tvm-logo" src={DambisLogo} />
                  </a>
                </div>
              </div>
              <div className="links">
                <p className="links_title">Useful link</p>
                <p>
                  <a href="https://cotown.eu/about/">{t("about")}</a>
                </p>
                <p>
                  <a href="https://cotown.eu/app">{t("cotownApp")}</a>
                </p>
                <p>
                  <a href="https://cotown.eu/contact/">{t("contact")}</a>
                </p>
                {user.length > 0 ? (
                <>
                  <button className="admin-btn" style={{marginBottom: '10px'}} onClick={logOutUser}>Logout</button>
                  <button className="admin-btn" onClick={checkAdminAreaNavigation}>Admin area</button>
                </>
                ) : (
                  <button className="admin-btn" style={{marginBottom: '10px'}} onClick={() => navigate("/login")}>Login</button>
                )}
              </div>
            </div>
          </div>
          <div className="column links_socials">
            <div className="links">
              <p className="links_title">Useful link</p>
              <p>
                <a href="https://cotown.eu/about/">{t("about")}</a>
              </p>
              <p>
                <a href="https://cotown.eu/app">{t("cotownApp")}</a>
              </p>
              <p>
                <a href="https://cotown.eu/contact/">{t("contact")}</a>
              </p>
              {user.length > 0 ? (
                <>
                  <button className="admin-btn" type="button" style={{marginBottom: '10px'}} onClick={logOutUser}>Logout</button>
                  <button className="admin-btn" type="button" onClick={checkAdminAreaNavigation}>Admin area</button>
                </>
                ) : (
                  <button className="admin-btn" type="button" style={{marginBottom: '10px'}} onClick={() => navigate("/login")}>Login</button>
                )}

            </div>
            <div className="socials_tablet">
              <p className="socials_title">Follow us</p>
              <div className="icons">
                <a
                  href="https://www.facebook.com/profile.php?id=61552642923441"
                  className="icons"
                  target="_blank"
                >
                  <img src={FacebookIcon} alt="Facebook Icon" />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61552642923441&sk=about"
                  className="icons"
                  target="_blank"
                >
                  <img src={TwitterIcon} alt="Facebook Icon" />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61552642923441&sk=about"
                  className="icons"
                  target="_blank"
                >
                  <img src={LinkedInIcon} alt="Facebook Icon" />
                </a>
              </div>
            </div>
          </div>
          <div className="column contact_information">
            <p className="contact_title">Information</p>
            <p>“Bratya Shkorpil” str. 9000, Varna, Bulgaria</p>
            <p>+359 988 919545</p>
            <p>infocotown@gmail.com</p>
          </div>
          <div className="column links_socials_wrapper_mobile">
            <div className="socials">
              <p className="socials_title">Follow us</p>
              <div className="icons">
                <a
                  href="https://www.facebook.com/profile.php?id=61552642923441"
                  className="icons"
                  target="_blank"
                >
                  <img src={FacebookIcon} alt="Facebook Icon" />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61552642923441&sk=about"
                  className="icons"
                  target="_blank"
                >
                  <img src={TwitterIcon} alt="Twitter Icon" />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61552642923441&sk=about"
                  className="icons"
                  target="_blank"
                >
                  <img src={LinkedInIcon} alt="Facebook Icon" />
                </a>
              </div>
            </div>
          </div>
          <div className="vertical_line_footer"></div>
          <div className="eu_container_mobile">
            <img
              className="eu_logo"
              width={90}
              height={60}
              src={EuropeLogoMobile}
            />
            <div className="eu_text">
              This project has received funding from the European Union’s
              Horizon 2020 research and innovation programme, under Grant
              Agreement No. 101005301
            </div>
          </div>
          <div className="sponsored_container_mobile">
            <img className="make-logo" src={MakeLogo} />
            <a href="https://www.tehnopol.ee/en/" target="_blank">
              <img className="tehnopol-logo" src={TechnopolLogo} />
            </a>
            
          </div>
          <div className="eu_sponsored_desktop">
            <img className="eu_logo_desktop" src={EULogo} />
            <div className="sponsors_desktop">
              <img className="make-logo" src={MakeLogo} />
              <a href="https://www.tehnopol.ee/en/" target="_blank">
                <img className="tehnopol-logo" src={TechnopolLogo} />
              </a>
            </div>
          </div>

        </div>
        <div className="horizontal_line_footer_tablet"></div>
        <div className="eu_sponsored_tablet">
          <img width={300} className="eu-logo" src={EULogo} />
          <img className="make-logo" src={MakeLogo} />
          <a href="https://www.tehnopol.ee/en/" target="_blank">
            <img className="tehnopol-logo" src={TechnopolLogo} />
          </a>
        </div>
        <div className="copyright_row">
          <div>Copyright © {currentYear} All rights reserved.</div>
          <div className="vertical_line_copyright_footer"></div>
          <div className="tvm_company_name">TVM Engineering Services Ltd.</div>
        </div>
    </footer>
  );
};

export default Footer;
